export default __webpack_public_path__ + "static/media/AudioVisual1.282b9993.mp4";